import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import { Modal, ModalContent, ModalDescription, ModalTitle } from '../../../../design-system/modal/modal';
import { Stack } from '../../../../design-system/stack/stack';
import { EmailDateRangeSelectionForm } from './email-date-range-selection-form';

type DateRangeFormValues = Parameters<ComponentProps<typeof EmailDateRangeSelectionForm>['onContinue']>[0];

type EmailConnectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelectDateRange: (values: DateRangeFormValues) => void;
};

export const EmailConnectionModal = ({ isOpen, onClose, onSelectDateRange }: EmailConnectionModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max max-w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Connect your email</ModalTitle>

          <ModalDescription>Connect your email</ModalDescription>
        </VisuallyHidden>

        <Stack space={3} align="stretch">
          <Stack space={1} align="stretch">
            <h1 className="text-xl leading-6 font-medium tracking-tight text-black">Connect Gmail Account</h1>

            <p className="text-base leading-6 font-normal tracking-tight text-muted-foreground">
              Choose how far back we should search your inbox for invoices.
            </p>
          </Stack>

          <EmailDateRangeSelectionForm onContinue={onSelectDateRange} onCancel={onClose} />
        </Stack>
      </ModalContent>
    </Modal>
  );
};
